"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvApiPrefix = exports.inferEnv = exports.DEFAULT_ENV = void 0;
exports.DEFAULT_ENV = 'prod';
function inferEnv(_a) {
    var _b = _a === void 0 ? {} : _a, 
    // if window doesn't exist, we are likely doing tests or SSR
    // fall back to the default value accordingly
    _c = _b.hostname, 
    // if window doesn't exist, we are likely doing tests or SSR
    // fall back to the default value accordingly
    hostname = _c === void 0 ? typeof window !== 'undefined' ? window.location.hostname : exports.DEFAULT_ENV : _c, _d = _b.defaultValue, defaultValue = _d === void 0 ? exports.DEFAULT_ENV : _d;
    if (hostname.match(/\bqa\b/)) {
        return 'qa';
    }
    if (hostname.match(/\bpprd\b/)) {
        return 'pprd';
    }
    if (hostname.match(/\blocalhost\b/)) {
        return 'local';
    }
    return defaultValue;
}
exports.inferEnv = inferEnv;
function getEnvApiPrefix(env) {
    switch (env) {
        case 'local':
            return 'qa.';
        case 'prod':
            return '';
        default:
            return encodeURIComponent(env) + '.';
    }
}
exports.getEnvApiPrefix = getEnvApiPrefix;
//# sourceMappingURL=env.js.map